/* eslint-disable */
import applicationStagesLabels from "../labels/applicationstages_en.json";
import jsPDF from 'jspdf';
import 'jspdf-autotable';

function getBase64Image(img) {
  var borderWidth = 2;
  var borderColor = "black";
  var canvas = document.createElement("canvas");
  canvas.width = img.width + 2 * borderWidth;
  canvas.height = img.height + 2 * borderWidth;
  var ctx = canvas.getContext("2d");

  ctx.fillStyle = borderColor;
  ctx.fillRect(0, 0, canvas.width, borderWidth);

  ctx.fillStyle = borderColor;
  ctx.fillRect(0, canvas.height - borderWidth, canvas.width, borderWidth);

  ctx.fillStyle = borderColor;
  ctx.fillRect(0, 0, borderWidth, canvas.height);

  ctx.fillStyle = borderColor;
  ctx.fillRect(canvas.width - borderWidth, 0, borderWidth, canvas.height);

  ctx.drawImage(img, borderWidth, borderWidth, img.width, img.height);
  var dataURL = canvas.toDataURL("image/png");
  return dataURL.replace(/^data:image\/(png|jpg|jpeg|pdf);base64,/, "");
}

const loadImageAsBase64 = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const borderWidth = 2;
        const borderColor = "black";
        canvas.width = img.width + 2 * borderWidth;
        canvas.height = img.height + 2 * borderWidth;
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = borderColor;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, borderWidth, borderWidth, img.width, img.height);
        const dataURL = canvas.toDataURL("image/png");
        const base64 = dataURL.replace(/^data:image\/(png|jpg|jpeg|pdf);base64,/, "");
        resolve(base64);
      };
      img.onerror = reject;
      img.src = src;
    });
  };

export const generateObjectionCountPDFWithoutPayment = async (getObjectionReportCountDetails) => {
  const pdfMargin = 20;
  const pdf = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    margins: {
      top: pdfMargin,
      bottom: pdfMargin,
      left: pdfMargin,
      right: pdfMargin,
    },
  });
  const image = document.createElement('img');
  image.src = "/logos/bpsc-banner.png";
  image.alt = "";
  image.setAttribute("data-toggle", "tooltip");
  image.setAttribute("data-placement", "bottom");
  image.setAttribute("title", "image");
  image.style.display = "block";
//   image.style.width = '100%';
//   image.style.height = '100%';
//   const imgData = getBase64Image(image);
  const imgData = await loadImageAsBase64("/logos/bpsc-banner.png");
  pdf.addImage(imgData, 'JPEG', 10, pdfMargin, 190, 50);
  pdf.setFontSize(12);

  const advertisementName = `${applicationStagesLabels.ADVT_NAME}`;
  const advertisementNameValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.advertisementName}`;
  pdf.setFont('helvetica', 'bold');
  pdf.text(advertisementName, 15, 95);
  pdf.setFont('helvetica', 'normal');
  pdf.text(advertisementNameValue, 52 + pdf.getStringUnitWidth(advertisementName), 95);

  const subjectsText = `${applicationStagesLabels.SUBJECT}`;
  const subjectsValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.subjectName}`;
  pdf.setFont('helvetica', 'bold');
  const subjectsTextX = 15;
  const subjectsTextY = 105;
  pdf.text(subjectsText, subjectsTextX, subjectsTextY);
  pdf.setFont('helvetica', 'normal');
  pdf.text(subjectsValue, 30 + pdf.getStringUnitWidth(subjectsText), 105);

  const additionalText = `${applicationStagesLabels.STUDENT_COUNT}`;
  const additionalValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.studentCount}`;
  pdf.setFont('helvetica', 'bold');
  const subjectsTextWidth = pdf.getStringUnitWidth(subjectsText) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
  const additionalTextX = subjectsTextX + subjectsTextWidth + 105;
  const additionalTextY = subjectsTextY;
  pdf.text(additionalText, additionalTextX, additionalTextY);
  pdf.setFont('helvetica', 'normal');
  pdf.text(additionalValue, 163 + pdf.getStringUnitWidth(additionalText), 105);

  const ObjectionCountData = getObjectionReportCountDetails.objectionQuestionCountList;
  const NoOfQues = ObjectionCountData.length;
  const totalCount = ObjectionCountData.reduce((sum, item) => {
    if (item.count) {
      return sum + item.count;
    }
    return sum;
  }, 0);

  const tableData = [];
  const totalRow = [{ content: `Total: ${NoOfQues}`, styles: { fontStyle: 'bold' } }, { content: `Total: ${totalCount}`, styles: { fontStyle: 'bold' } }];
  for (let i = 0; i <= ObjectionCountData.length; i++) {
    if (ObjectionCountData && ObjectionCountData[i]) {
      let QueNo = ObjectionCountData && ObjectionCountData[i].questionNo;
      let count = ObjectionCountData && ObjectionCountData[i].count;
      tableData.push([QueNo, count]);
    }
  };

  tableData.push(totalRow);

  pdf.autoTable({
    startY: subjectsTextY + 10,
    startY: 110,
    head: [['Question No.', 'Count']],
    body: tableData,
    theme: 'grid',
    styles: {
      halign: 'center',
      valign: 'middle',
      fontSize: 12,
    },
    headStyles: {
      fillColor: [238, 238, 238],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      cellWidth: 'wrap',
      lineWidth: 0.1,
    },
    tableLineColor: [0, 0, 0],
    didDrawPage: data => {
      const pageCountString = `Page ${data.pageNumber} of ${pdf.internal.getNumberOfPages()}`;
      const pageSize = pdf.internal.pageSize;
      const textWidth = pdf.getStringUnitWidth(pageCountString) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
      const x = (pageSize.width - textWidth) / 2;
      pdf.setFontSize(10);
      pdf.setTextColor(150);
      pdf.text(pageCountString, x, pageSize.height - 10);
    },
    didDrawCell: data => {
      const borderWidth = 0.2;
      const borderColor = "black";
      const cell = data.cell;
      const { x, y, width, height } = cell;

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y, x + width, y);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y, x, y + height);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y + height, x + width, y + height);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x + width, y, x + width, y + height);
    },
  });
  return pdf.save('ObjectionCount.pdf');
};

export const generateObjectionCountPDFWithPayment = async (getObjectionReportCountDetails) => {
  const pdfMargin = 20;
  const pdf = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    margins: {
      top: pdfMargin,
      bottom: pdfMargin,
      left: pdfMargin,
      right: pdfMargin,
    },
  });
  const image = document.createElement('img');
  image.src = "/logos/bpsc-banner.png";
  image.alt = "";
  image.setAttribute("data-toggle", "tooltip");
  image.setAttribute("data-placement", "bottom");
  image.setAttribute("title", "image");
  image.style.display = "block";
//   image.style.width = '100%';
//   image.style.height = '100%';
//   const imgData = getBase64Image(image);
   const imgData = await loadImageAsBase64("/logos/bpsc-banner.png");

  pdf.addImage(imgData, 'JPEG', 10, pdfMargin, 190, 50);
  pdf.setFontSize(12);

  const advertisementName = `${applicationStagesLabels.ADVT_NAME}`;
  const advertisementNameValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.advertisementName}`;
  pdf.setFont('helvetica', 'bold');
  pdf.text(advertisementName, 15, 95);
  pdf.setFont('helvetica', 'normal');
  pdf.text(advertisementNameValue, 52 + pdf.getStringUnitWidth(advertisementName), 95);

  const subjectsText = `${applicationStagesLabels.SUBJECT}`;
  const subjectsValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.subjectName}`;
  pdf.setFont('helvetica', 'bold');
  const subjectsTextX = 15;
  const subjectsTextY = 105;
  pdf.text(subjectsText, subjectsTextX, subjectsTextY);
  pdf.setFont('helvetica', 'normal');
  pdf.text(subjectsValue, 30 + pdf.getStringUnitWidth(subjectsText), 105);

  const additionalText = `${applicationStagesLabels.STUDENT_COUNT}`;
  const additionalValue = `${getObjectionReportCountDetails && getObjectionReportCountDetails.studentCount}`;
  pdf.setFont('helvetica', 'bold');
  const subjectsTextWidth = pdf.getStringUnitWidth(subjectsText) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
  const additionalTextX = subjectsTextX + subjectsTextWidth + 105;
  const additionalTextY = subjectsTextY;
  pdf.text(additionalText, additionalTextX, additionalTextY);
  pdf.setFont('helvetica', 'normal');
  pdf.text(additionalValue, 163 + pdf.getStringUnitWidth(additionalText), 105);

  const ObjectionCountData = getObjectionReportCountDetails.objectionQuestionCountList;
  const NoOfQues = ObjectionCountData.length;
  const totalCount = ObjectionCountData.reduce((sum, item) => {
    if (item.count) {
      return sum + item.count;
    }
    return sum;
  }, 0);

  const totalPaymentCount = ObjectionCountData.reduce((sum, item) => {
    if (item.payment) {
      return sum + item.payment;
    }
    return sum;
  }, 0);

  const tableData = [];
  const totalRow = [{ content: `Total: ${NoOfQues}`, styles: { fontStyle: 'bold' } }, { content: `Total: ${totalCount}`, styles: { fontStyle: 'bold' } }, { content: `Total: ${totalPaymentCount}`, styles: { fontStyle: 'bold' } }];
  for (let i = 0; i <= ObjectionCountData.length; i++) {
    if (ObjectionCountData && ObjectionCountData[i]) {
      let QueNo = ObjectionCountData && ObjectionCountData[i].questionNo;
      let count = ObjectionCountData && ObjectionCountData[i].count;
      let paymentCount = ObjectionCountData && ObjectionCountData[i].payment;
      tableData.push([QueNo, count, paymentCount]);
    }
  };

  tableData.push(totalRow);

  pdf.autoTable({
    startY: subjectsTextY + 10,
    startY: 110,
    head: [['Question No.', 'Count', 'Payment']],
    body: tableData,
    theme: 'grid',
    styles: {
      halign: 'center',
      valign: 'middle',
      fontSize: 12,
    },
    headStyles: {
      fillColor: [238, 238, 238],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      cellWidth: 'wrap',
      lineWidth: 0.1,
    },
    tableLineColor: [0, 0, 0],
    didDrawPage: data => {
      const pageCountString = `Page ${data.pageNumber} of ${pdf.internal.getNumberOfPages()}`;
      const pageSize = pdf.internal.pageSize;
      const textWidth = pdf.getStringUnitWidth(pageCountString) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
      const x = (pageSize.width - textWidth) / 2;
      pdf.setFontSize(10);
      pdf.setTextColor(150);
      pdf.text(pageCountString, x, pageSize.height - 10);
    },
    didDrawCell: data => {
      const borderWidth = 0.2;
      const borderColor = "black";
      const cell = data.cell;
      const { x, y, width, height } = cell;

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y, x + width, y);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y, x, y + height);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x, y + height, x + width, y + height);

      pdf.setDrawColor(borderColor);
      pdf.setLineWidth(borderWidth);
      pdf.line(x + width, y, x + width, y + height);
    },
  });
  return pdf.save('PaidObjectionCount.pdf');
};

export const generatePdf = (eligibleCandidateListDetails) => {
  const pdfMargin = 20;
  const pageWidth = 260 - pdfMargin * 2;

  const doc = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    margins: {
      top: pdfMargin,
      bottom: pdfMargin,
      left: pdfMargin,
      right: pdfMargin,
    },
  });

  const addHeader = (page) => {
    // const img = new Image();
    // img.src = '/logos/bpsc-banner.png';
    // doc.addImage(img, 'JPEG', 10, 10, 200, 35);
    // doc.setLineWidth(0.3);
    // doc.rect(15, 10, 188, 35);
    // doc.setFontSize(12);

    const img = new Image();
    img.src = '/logos/bpsc-banner.png';
    doc.addImage(img, 'JPEG', -15, 10, 250, 50);
    doc.setLineWidth(0.4);
    doc.rect(6, 10, 197, 48);
    doc.setFontSize(12);


    const content = eligibleCandidateListDetails && eligibleCandidateListDetails.post;
    const splitContent = doc.splitTextToSize(content, pageWidth);

    const startY = 64;
    const lineHeight = 10;

    splitContent.forEach((line, index) => {
      doc.setFontSize(10);
      if (index === 0) {
        doc.text(line, 11, startY);
      } else {
        const additionalMargin = -6;
        doc.text(line, 11, startY + index * lineHeight + additionalMargin);
      }
    });

    const advtText = eligibleCandidateListDetails && eligibleCandidateListDetails.advtNo;
    const newPageWidth = doc.internal.pageSize.getWidth();
    const advtTextWidth = doc.getTextWidth(advtText);
    const advtTextX = (newPageWidth - advtTextWidth) / 2;

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(advtText, advtTextX, startY + 11);

    const reportTitleText = eligibleCandidateListDetails && eligibleCandidateListDetails.reportTitle;
    const reportTitlePageWidth = doc.internal.pageSize.getWidth();
    const reportTitleWidth = doc.getTextWidth(reportTitleText);
    const reportTitleX = (reportTitlePageWidth - reportTitleWidth) / 2;

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(reportTitleText, reportTitleX + 4, startY + 17);

    const venueTitleText = "VENUE :";
    const venueTitlePageWidth = doc.internal.pageSize.getWidth();
    const venueTitleWidth = doc.getTextWidth(venueTitleText);
    const venueTitleX = (venueTitlePageWidth - venueTitleWidth) / 2;

    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(venueTitleText, venueTitleX - 91, startY + 24);

    const venuePageWidth = 230 - pdfMargin * 2;
    const venueContent = eligibleCandidateListDetails && eligibleCandidateListDetails.venue;
    const splitVenueContent = doc.splitTextToSize(venueContent, venuePageWidth);
    const venueStartY = 88;
    const venueLineHeight = 10;
    splitVenueContent.forEach((line, index) => {
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      if (index === 0) {
        doc.text(line, 23, venueStartY);
      } else {
        const additionalMargin = -6;
        doc.text(line, 23, venueStartY + index * venueLineHeight + additionalMargin);
      }
    });

    if (page > 1) {
      doc.addPage();
    }
  };

  const tableHeader = [
    ['Int. No.', 'Registration No.', 'Name', 'Interview Date', 'Interview Time']
  ];

  let tableData = eligibleCandidateListDetails && eligibleCandidateListDetails.eligibleCandidateList;

  const addTable = (startY) => {
    doc.autoTable({
      startY,
      margin: { left: 6, right: 7 },
      head: [tableHeader[0]],
      body: (tableData) && (tableData.length > 0) ? tableData.map((row, index) => [
        index + 1,
        row.profileTransactionID,
        row.candidateName,
        row.interview_date,
        row.interview_time
      ])
        :
        [[{ content: 'No data found', colSpan: 5, styles: { halign: 'center' } }]]
      ,
      theme: 'grid',
      headStyles: {
        fontStyle: 'bold',
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 0.4,
        lineColor: [0, 0, 0],
        halign: 'center'
      },
      styles: {
        fontSize: 10,
        cellPadding: 2,
        lineWidth: 0.4,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0]
      },
      columnStyles: {
        0: { cellWidth: 15, halign: 'center' },
        1: { cellWidth: 55, halign: 'left' },
        2: { cellWidth: 65, halign: 'left' },
        3: { cellWidth: 30, halign: 'center' },
        4: { cellWidth: 25, halign: 'center' },
      },
    });
  };
  const headerHeight = 75;
  const startY = pdfMargin + headerHeight;
  addHeader(1);
  addTable(startY);
  let extractedData = eligibleCandidateListDetails && eligibleCandidateListDetails.advtNo.split(':')[1].trim();
  let parts = extractedData.split('/');
  let part1 = parts[0].trim();
  let part2 = parts[1].trim()

  doc.save(`Adv_${part1}_${part2}_InterviewScheduled.pdf`);
};


export const generateMusterReportPdf = (eligibleCandidateListDetails, interviewPtLetterReportName) => {
  const pdfMargin = 20;
  const startY = 48;
  const doc = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    margins: {
      top: pdfMargin,
      bottom: pdfMargin,
      left: pdfMargin,
      right: pdfMargin,
    },
  });

  const addHeader = (page) => {
    const img = new Image();
    img.src = '/logos/bpsc-banner.png';
    doc.addImage(img, 'JPEG', -5, 10, 230, 50);
    doc.setLineWidth(0.4);
    doc.rect(15, 10, 180, 48);
    doc.setFontSize(12);

    const reportTitleText = (interviewPtLetterReportName === "ATTENDANCE MUSTER") ? 'ATTENDANCE MUSTER' : (interviewPtLetterReportName === "TOKEN MUSTER") ? "TOKEN MUSTER" : (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? "TOKEN MAPPING REPORT" : (interviewPtLetterReportName === "VERIFICATION MUSTER") ? "VERIFICATION MUSTER" : '';
    const reportTitlePageWidth = doc.internal.pageSize.getWidth();
    const reportTitleWidth = doc.getTextWidth(reportTitleText);
    const reportTitleX = (reportTitlePageWidth - reportTitleWidth) / 2;
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text(reportTitleText, reportTitleX + 4, startY + 17);
    doc.rect(15, 10, 180, 48);

    if (page > 1) {
      doc.addPage();
    };

    const lineHeight = 10;
    let currentY = 78;
    const smallLineHeight = 6;

    const wrapText = (text, maxWidth) => {
      const words = text.split(' ');
      let lines = [];
      let currentLine = words[0];

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const width = doc.getTextWidth(currentLine + " " + word);
        if (width < maxWidth) {
          currentLine += " " + word;
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      }
      lines.push(currentLine);
      return lines;
    };

    const addLabelValue = (label, value, x, y, index) => {
      doc.setFont("helvetica", "bold");
      doc.text(label, x, y);
      const labelWidth = doc.getTextWidth(label);
      const valueX = x + labelWidth + (index == "1" ? 22 : index == "2" ? 2 : index == "3" ? 26 : index == "4" ? 27 : 2);
      doc.setFont("times", "normal");
      const maxWidth = 210 - valueX - 15;
      const lines = wrapText(value, maxWidth);
      lines.forEach((line, i) => {
        const yOffset = i === 0 ? 0 : smallLineHeight;
        doc.text(line, valueX, y + i * yOffset);
      });
      return y + lines.length * smallLineHeight;
    };

    let advtNo = eligibleCandidateListDetails && eligibleCandidateListDetails.advtNo;
    let postName = eligibleCandidateListDetails && eligibleCandidateListDetails.post;
    let examCenter = eligibleCandidateListDetails && eligibleCandidateListDetails.examCenter;
    let venue = eligibleCandidateListDetails && eligibleCandidateListDetails.venue;
    let committeeNo = eligibleCandidateListDetails && eligibleCandidateListDetails.committeeNo;
    let date = eligibleCandidateListDetails && eligibleCandidateListDetails.date;
    let time = eligibleCandidateListDetails && eligibleCandidateListDetails.time;

    addLabelValue("Advt. No :", advtNo, 18, currentY, 1);
    currentY += lineHeight - 3;
    addLabelValue("Name of Post/Exam :", postName, 18, currentY, 2);
    currentY += lineHeight + 6;
    addLabelValue("Centre :", examCenter, 18, currentY, 3);
    currentY += lineHeight - 2;
    addLabelValue("Venue :", venue, 18, currentY, 4);
    currentY += lineHeight + 7;
    const x1 = 18;
    const x2 = 80;
    const x3 = 140;
    doc.setFont("helvetica", "bold");
    doc.text("Committee No:", x1, currentY);
    doc.text("Date :", x2, currentY);
    doc.text("Time :", x3, currentY);
    doc.setFont("times", "normal");
    doc.text(committeeNo, x1 + doc.getTextWidth("Committee No :") + 3, currentY);
    doc.text(date, x2 + doc.getTextWidth("Date :") + 2, currentY);
    doc.text(time, x3 + doc.getTextWidth("Time :") + 2, currentY);
    currentY += lineHeight;
    doc.rect(15, 70, 180, 60);
  };

  const tableHeader = [
    ['Interview No.', 'Name of the Candidate', 'Signature of Candidate']
  ];

  const tokenMusterHeader = [
    ['Token No.', 'Name of the Candidate', 'Signature of Candidate']
  ];

  const tokenMappingHeader = [
    ['Transaction No.', 'Name of the Candidate', 'Interview No.', 'Token No.', 'Signature of Candidate']
  ];

  const verificationMusterHeader = [
    ['Sr. No.', 'Name/Int. No./Roll No./Application Id. of the Candidate', 'Photo & Signature of the Candidate', 'Signature of the Candidate']
  ];

  let tableData = eligibleCandidateListDetails && eligibleCandidateListDetails.candidateList;

  let columnStylesData = {
    0: { cellWidth: 35, halign: 'center' },
    1: { cellWidth: 90, halign: 'left' },
    2: { cellWidth: 55, halign: 'center' },
  };

  let tokenMappingReportColumnStylesData = {
    0: { cellWidth: 51, halign: 'left' },
    1: { cellWidth: 46, halign: 'left' },
    2: { cellWidth: 23, halign: 'center' },
    3: { cellWidth: 20, halign: 'center' },
    4: { cellWidth: 40, halign: 'center' },
  };

  let verificationMusterColumnStylesData = {
    0: { cellWidth: 15, halign: 'center' },
    1: { cellWidth: 80, halign: 'left' },
    2: { cellWidth: 46, halign: 'center' },
    3: { cellWidth: 40, halign: 'center' },
  };

  const addTable = (startY) => {
    doc.autoTable({
      startY,
      margin: { left: 15, right: 7 },
      head: [(interviewPtLetterReportName === "ATTENDANCE MUSTER") ? tableHeader[0] : (interviewPtLetterReportName === "TOKEN MUSTER") ? tokenMusterHeader[0] : (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? tokenMappingHeader[0] : (interviewPtLetterReportName === "VERIFICATION MUSTER") ? verificationMusterHeader[0] : ''],
      body: (tableData) && (tableData.length > 0) && (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? tableData.map((row) => [
        row.profileTransactionID,
        row.candidateName,
        row.interview_no,
        row.interview_token_no,
        ''
      ])
        :
        (interviewPtLetterReportName === "ATTENDANCE MUSTER") ? tableData.map((row) => [
          row.interview_no,
          row.candidateName,
          ''
        ])
          :
          (interviewPtLetterReportName === "TOKEN MUSTER") ? tableData.map((row) => [
            row.interview_token_no,
            row.candidateName,
            ''
          ])
            :
            (interviewPtLetterReportName === "VERIFICATION MUSTER") ? tableData.map((row, index) => [
              index + 1,
              `${row.candidateName}\nInterview No: ${row.interview_no}\nRoll No P1: ${row.roll_No1}\nRoll No P2: ${row.roll_No2}\nApplication ID: ${row.profileTransactionID}`,
              {
                'images': [
                  row.photo ? `data:image/png;base64,${row.photo}` : "",
                  row.signature ? `data:image/png;base64,${row.signature}` : ""
                ]
              },
              ''
            ])
              :
              [[{ content: 'No data found', colSpan: (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? 5 : (interviewPtLetterReportName === "VERIFICATION MUSTER") ? 4 : 3, styles: { halign: 'center' } }]]
      ,
      didDrawCell: (data) => {
        if (data.column.index === 2 && data.cell.raw && data.cell.raw.images) {
          const cellWidth = data.cell.width;
          const cellHeight = data.cell.height;
          const margin = 5; 
          const maxImageWidth = cellWidth - 3 * margin;
          data.cell.raw.images.forEach((image, idx) => {
            if (image && (idx === 0)) {
              const imgProps = doc.getImageProperties(image);
              const aspectRatio = imgProps.width / imgProps.height;
              let imgWidth, imgHeight;
              // if (aspectRatio > 1) {
              //   imgWidth = cellWidth - 2 * margin;
              //   imgHeight = (cellWidth - 2 * margin) / aspectRatio;
              // } else {
              //   imgWidth = (cellHeight / 2 - 2 * margin) * aspectRatio;
              //   imgHeight = cellHeight / 2 - 2 * margin;
              // }
              if (aspectRatio > 1) {
                imgWidth = maxImageWidth;
                imgHeight = maxImageWidth / aspectRatio;
              } else {
                imgWidth = maxImageWidth * aspectRatio;
                imgHeight = maxImageWidth;
              }
              const x = data.cell.x + (cellWidth - imgWidth) / 2;
              const y = data.cell.y + idx * cellHeight / 2 + (cellHeight / 2 - imgHeight) / 2;
              doc.addImage(image, 'PNG', x + margin - 5, y + margin + 5, imgWidth + 1, imgHeight - 11);
            }
            if (image && (idx === 1)) {
              const imgProps = doc.getImageProperties(image);
              const aspectRatio = imgProps.width / imgProps.height;
              let imgWidth, imgHeight;
              // if (aspectRatio > 1) {
              //   imgWidth = cellWidth - 2 * margin;
              //   imgHeight = (cellWidth - 2 * margin) / aspectRatio;
              // } else {
              //   imgWidth = (cellHeight / 2 - 2 * margin) * aspectRatio;
              //   imgHeight = cellHeight / 2 - 2 * margin;
              // }
              if (aspectRatio > 1) {
                imgWidth = maxImageWidth;
                imgHeight = maxImageWidth / aspectRatio;
              } else {
                imgWidth = maxImageWidth * aspectRatio;
                imgHeight = maxImageWidth;
              }
              const x = data.cell.x + (cellWidth - imgWidth) / 2;
              const y = data.cell.y + idx * cellHeight / 2 + (cellHeight / 2 - imgHeight) / 2;
              doc.addImage(image, 'PNG', x + margin - 1, y + margin - 3, imgWidth - 7, imgHeight - 180);
            }
          });
        }
      },
      theme: 'grid',
      headStyles: {
        fontStyle: 'bold',
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 0.4,
        lineColor: [0, 0, 0],
        halign: (interviewPtLetterReportName === "VERIFICATION MUSTER") ? 'center' : 'left',
        fontSize: 10,
        cellPadding: 4
      },
      styles: {
        fontSize: 10,
        cellPadding: 3,
        lineWidth: 0.4,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0]
      },
      columnStyles: (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? tokenMappingReportColumnStylesData : (interviewPtLetterReportName === "VERIFICATION MUSTER") ? verificationMusterColumnStylesData : columnStylesData,
    });
  };
  const headerHeight = 118;
  const tableStartY = pdfMargin + headerHeight;
  addHeader(1);
  addTable(tableStartY);
  const totalPages = doc.getNumberOfPages();
  doc.setPage(totalPages);
  const pageHeight = doc.internal.pageSize.height;
  const marginBottom = 10;
  const rectHeight = 23;
  const rectWidth = 181;
  const rectX = 15;
  const rectY = pageHeight - marginBottom - rectHeight;
  doc.rect(rectX, rectY, rectWidth, rectHeight);
  const verticalLineX = rectX + (rectWidth * 0.6);
  doc.line(verticalLineX, rectY, verticalLineX, rectY + rectHeight);
  const lineHeight = 6;
  const paddingLeft = 2;
  const textY = rectY + lineHeight;
  const nameText = "Name:";
  const nameDots = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ ";
  const dateText = "Date:";
  const dateDots = "_ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _";
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text(nameText, rectX + paddingLeft, textY + 2);
  doc.text(dateText, rectX + paddingLeft, textY + lineHeight + 5);
  doc.setFont("times", "normal");
  doc.setFontSize(11);
  const nameTextWidth = doc.getTextWidth(nameText) + 2;
  const dateTextWidth = doc.getTextWidth(dateText) + 2;
  doc.text(nameDots, rectX + paddingLeft + nameTextWidth, textY + 2);
  doc.text(dateDots, rectX + paddingLeft + dateTextWidth, textY + lineHeight + 5);
  const text40PercentBlock = "Signature of Concerned Officer";
  const textWidth = doc.getTextWidth(text40PercentBlock);
  const textX40 = verticalLineX + ((rectWidth * 0.4) - textWidth) / 2;
  const textY40 = rectY + rectHeight - 5;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text(text40PercentBlock, textX40 - 3, textY40);
  doc.save(`${(interviewPtLetterReportName === "ATTENDANCE MUSTER") ? "AttendanceMuster.pdf" : (interviewPtLetterReportName === "VERIFICATION MUSTER") ? "VerificationMuster.pdf" : (interviewPtLetterReportName === "TOKEN MUSTER") ? "TokenMuster.pdf" : (interviewPtLetterReportName === "TOKEN MAPPING REPORT") ? "TokenMappingReport.pdf" : ''}`);
};